<template>
  <div class="app-contianer">
    <div class="left">
      <div class="logo-box" :class="{ isCollapse }">
        <img class="logo" src="../assets/jdlogo.png" alt="" />
      </div>
      <el-menu :default-active="path" class="el-menu-vertical-demo" :collapse="isCollapse" router>
        <template v-for="(item, index) in menus">
          <component :is="item.child && item.child.length > 0 ? 'el-submenu' : 'el-menu-item'" :key="index" class="menu-item" :index="item.route">
            <template v-if="item.child && item.child.length > 0" slot="title">
              <icon-font class="menu-icon" :type="item.icon" />
              <span>{{ item.dispalyName }}</span>
            </template>
            <template v-else>
              <icon-font class="menu-icon" :type="item.icon" />
              <span slot="title">{{ item.dispalyName }}</span>
            </template>
            <template v-if="item.child && item.child.length > 0">
              <template v-for="(tow, i) in item.child">
                <component :is="tow.child && tow.child.length > 0 ? 'el-submenu' : 'el-menu-item'" :key="i" class="menu-item" :index="tow.route">
                  <template v-if="tow.child && tow.child.length > 0" slot="title">
                    <icon-font class="menu-icon" :type="tow.icon" />
                    <span>{{ tow.dispalyName }}</span>
                  </template>
                  <template v-else>
                    <icon-font class="menu-icon" :type="tow.icon" />
                    <span slot="title">{{ tow.dispalyName }}</span>
                  </template>
                  <template v-if="tow.child && tow.child.length > 0">
                    <template v-for="(s, i) in tow.child">
                      <el-menu-item :key="i" :index="s.route">
                        <icon-font class="menu-icon" :type="s.icon" />
                        <span slot="title">{{ s.dispalyName }}</span>
                      </el-menu-item>
                    </template>
                  </template>
                </component>
              </template>
            </template>
          </component>
        </template>
      </el-menu>
      <div class="version-box">{{ version }}</div>
    </div>
    <div class="right">
      <Header @collapse="isCollapse = !isCollapse" :isCollapse="isCollapse" />
      <TagsView />
      <div class="mian-box">
        <div class="mian-contianer">
          <transition name="fade-transform" mode="out-in">
            <keep-alive :include="includePage">
              <router-view />
            </keep-alive>
          </transition>
        </div>
      </div>
      <!-- <div class="footer">
        <span style="padding: 0 10px"
          >Copyright @2021 成都垣景科技有限公司
        </span>
        |<a 
          class="a_beian"
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010602001507"
          ><img src="../assets/imgs/gongan.png" style="float: left" />川公网安备
          51010602001507号 </a
        >|<a class="a_beian" target="_blank" href="https://beian.miit.gov.cn">
          蜀ICP备18016899号-2
        </a>
      </div> -->
    </div>
  </div>
</template>
<script>
import Header from "./components/Header";
import TagsView from "./components/TagView";
export default {
  name: "Layout",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlice: true,
      isCollapse: false,
      includePage: ["AddProject", "Project"],
    };
  },
  components: {
    Header,
    TagsView,
  },
  watch: {
    isCollapse() {
      setTimeout(() => {
        window.addEventListener("resize", () => {}, false);
      }, 300);
    },
  },
  computed: {
    path() {
      return this.$route.path;
    },
    menus() {
      return this.$store.state.user.menuList;
    },
    companyLogo() {
      return this.$store.state.user.userInfo?.companyLogo;
    },
    companyName() {
      return this.$store.state.user.userInfo?.companyName;
    },
    authList() {
      return this.$store.state.user.auth;
    },
    baseUrl() {
      return window.xindu.appconst.webApiUrl;
    },
    version() {
      return process.env.VUE_APP_VERSION;
    },
  },
  methods: {
    error() {
      this.$store.state.user.companyInfo.Logo = "";
    },
    reload() {
      this.isRouterAlice = false;
      this.$nextTick(function () {
        this.isRouterAlice = true;
      });
    },
    setIcon(str) {
      const arr = str.split("/");
      return arr[arr.length - 1];
    },
    isShow(data) {
      // if (process.env.NODE_ENV === "development") return true;
      if (this.authList.indexOf(data.auth) != -1 || data.auth == "true") {
        if (data.Childs?.length) {
          let flag = false;
          for (let index = 0; index < data.Childs.length; index++) {
            if (this.authList.indexOf(data.Childs[index].auth) != -1) {
              flag = true;
              return true;
            }
          }
          return flag;
        }
        return true;
      } else if (this.authList.indexOf(data.auth2) != -1) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.app-contianer {
  display: flex;
  height: 100%;
  text-align: left;
  background: #eaedf1;
  .left {
    transition: all 0.3s;
    height: 100%;
    overflow: hidden;
    border-right: solid 1px #e6e6e6;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    position: relative;
    background-color: #ffffff;
    flex-shrink: 0;
    padding-bottom: 20px;
    .logo-box {
      height: 50px;
      border-bottom: solid 1px #e6e6e6;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px;
      transition: all 0.3s;
      span {
        font-size: 14px;
        font-weight: bold;
        color: #3a87e4;
        margin-left: 10px;
        transition: all 0.3s;
        width: 128px;
        white-space: nowrap;
        overflow: hidden;
        display: inline-block;
      }
      &.isCollapse {
        width: 64px;
        span {
          width: 0;
          margin-left: 0;
        }
      }
    }
    .el-menu {
      height: calc(100% - 50px);
      overflow-x: hidden;
      overflow-y: auto;
      border: none;
      &:not(.el-menu--collapse) {
        width: 200px;
      }
    }
    .copyright {
      position: absolute;
      font-size: 12px;
      bottom: 0;
      width: 100%;
      text-align: center;
      line-height: 20px;
      padding-bottom: 4px;
      overflow: auto;
      span {
        height: 1px;
        background: #cccccc;
        width: 180px;
        display: block;
        margin: 0 auto;
      }
    }
    .version-box {
      position: absolute;
      background-color: #ffffff;
      bottom: 0;
      font-size: 12px;
      text-align: center;
      width: 100%;
      line-height: 20px;
    }
  }
  .right {
    flex: 1;
    overflow: hidden;
    .mian-box {
      width: 100%;
      height: calc(100% - 84px);
      overflow-x: hidden;
      overflow-y: hidden;
    }
    .mian-contianer {
      margin: 10px;
      // margin-bottom: 0;
      border-radius: 4px;
      height: calc(100% - 20px);
      // height: calc(100% - 136px);
      // min-width: 1280px;
      width: calc(100% - 20px);
      > div {
        height: 100%;
        background: #ffffff;
      }
    }
    .footer {
      height: 30px;
      background-color: #ffffff;
      text-align: center;
      font-size: 12px;
      line-height: 30px;
      min-width: 1332px;
      .a_beian {
        color: #2c3e50;
        display: inline-block;
        text-decoration: none;
        height: 20px;
        line-height: 20px;
        margin: 0 10px;
        &:hover {
          color: rgb(90, 147, 255);
        }
      }
    }
  }
  .menu-icon {
    font-size: 20px;
    vertical-align: middle;
    margin-right: 8px;
  }
}
.logo {
  width: 30px;
  transition: all 0.3s;
}
.biglogo {
  width: 96px;
  transition: all 0.3s;
}
</style>
